module.exports = __webpack_public_path__ + "img/Tiere.aed74e65.jpg";